export default __webpack_public_path__ + "static/media/1.feb51666.jpg";